import 'moment-timezone';

import * as localForage from 'localforage';

import { Injectable } from '@angular/core';
import { createStore } from '@ngneat/elf';
import { deleteAllEntities, getAllEntities, getEntity, upsertEntities, withEntities } from '@ngneat/elf-entities';
import { clearRequestsCache, createRequestsCacheOperator, createRequestsStatusOperator, initializeAsPending, updateRequestCache, updateRequestStatus, withRequestsCache, withRequestsStatus,} from '@ngneat/elf-requests';
import { persistState } from '@shared/third-party/persist-state/persist-state';

import { ActiveReservationRepository } from '@shared/state/reservations/active-reservation.repository';
import { BaseRepository } from '../base.repository';
import { STORETIMEOUT } from '../db';

export interface Employees {
	email: string;
	employee_id: number;
	first_name: string;
	last_name: string;
	main_phone: string;
	role_name: string;
	user_id: number;
}

const store = createStore(
	{ name: 'employees' },
	withEntities<Employees, 'employee_id'>({ idKey: 'employee_id' }),
	withRequestsStatus<`employees`>(initializeAsPending('employees')),
	withRequestsCache<`employees`>()
);
export const trackEmployeesRequestsStatus = createRequestsStatusOperator(store);
export const persist = persistState(store, {
	key: 'employees',
	storage: localForage,
});
export const skipWhileEmployeesCached = createRequestsCacheOperator(store);
setInterval(() => store.update(clearRequestsCache()), STORETIMEOUT);

@Injectable({ providedIn: 'root' })
export class EmployeesRepository extends BaseRepository {
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(private readonly activeReservationRepo: ActiveReservationRepository) {
		super();
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - store
	 **-------------------------------------------------------------------------------------
	 */
	get store() {
		return store;
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - queries
	 **-------------------------------------------------------------------------------------
	 */
	getAll = () => store.query(getAllEntities());
	get = id => store.query(getEntity(id));

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - add
	 **-------------------------------------------------------------------------------------
	 */
	public add(items) {
		store.update(
			deleteAllEntities(),
			upsertEntities(items),
			updateRequestCache('employees', { ttl: STORETIMEOUT }),
			updateRequestStatus('employees', 'success')
		);
	}

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - getAssignedEmployee
	 **-------------------------------------------------------------------------------------
	 */
	public getAssignedEmployee = (reservationId: number) => {
		const employeeId = this.activeReservationRepo.get(reservationId, 'assignedEmployeeId');
		return this.get(employeeId);
	};
}
